interface ExistingQuestionsAddedInput {
  reusedQuestionCount: number;
  addFullAddress: boolean;
}

type ExistingQuestionsAddedEvent = {
  questions_added_count: number;
  source: "modal";
};

export const buildExistingQuestionsAddedEvent = ({
  reusedQuestionCount,
  addFullAddress,
}: ExistingQuestionsAddedInput): ExistingQuestionsAddedEvent | null => {
  const questionsAddedCount = reusedQuestionCount + (addFullAddress ? 1 : 0);

  if (questionsAddedCount === 0) {
    return null;
  }

  return { questions_added_count: questionsAddedCount, source: "modal" };
};
